/**
 * Override for interpreter nativeToPseudo method
 * @param nativeObj
 * @param key
 * @returns
 */
Interpreter.prototype.nativeToPseudo = function (nativeObj) {
  if (
    typeof nativeObj === 'boolean' ||
    typeof nativeObj === 'number' ||
    typeof nativeObj === 'string' ||
    nativeObj === null ||
    nativeObj === undefined
  ) {
    return nativeObj;
  }

  if (nativeObj instanceof RegExp) {
    var pseudoRegexp = this.createObjectProto(this.REGEXP_PROTO);
    this.populateRegExp(pseudoRegexp, nativeObj);
    return pseudoRegexp;
  }

  var thisInterpreter;
  if (nativeObj instanceof Function) {
    thisInterpreter = this;
    var wrapper = function () {
      var returnObj = nativeObj.apply(nativeObj, arguments);
      if (typeof returnObj !== 'undefined') {
        return thisInterpreter.nativeToPseudo(returnObj);
      } else {
        return thisInterpreter.UNDEFINED;
      }
    };
    return this.createNativeFunction(wrapper);
  }

  var pseudoObj;
  // Array.
  if (nativeObj instanceof Array) {
    pseudoObj = this.createObject(this.ARRAY);
    for (var i = 0; i < nativeObj.length; i++) {
      this.setProperty(pseudoObj, i, this.nativeToPseudo(nativeObj[i]));
    }
  }
  // Object.
  else {
    thisInterpreter = this;
    pseudoObj = this.createObject(this.OBJECT);
    Object.getOwnPropertyNames(nativeObj).forEach((key) => {
      pseudoObj.id = nativeObj['_id'];
      pseudoObj.type = nativeObj['_type'];

      var descriptor = Object.getOwnPropertyDescriptor(nativeObj, key);
      if (
        typeof descriptor.get === 'function' &&
        typeof descriptor.set === 'function'
      ) {
        var getter = this.createNativeFunction(function () {
          var returnObj = descriptor.get.apply(nativeObj);
          if (typeof returnObj !== 'undefined') {
            return thisInterpreter.nativeToPseudo(returnObj);
          } else {
            return thisInterpreter.UNDEFINED;
          }
        });
        var setter = this.createNativeFunction(function () {
          descriptor.set.apply(nativeObj, arguments);
        });
        this.setProperty(pseudoObj, key, ReferenceError, {
          enumerable: false,
          configurable: false,
          get: getter,
          set: setter
        });
      } else {
        this.setProperty(pseudoObj, key, this.nativeToPseudo(nativeObj[key]));
      }
    });
  }
  return pseudoObj;
};
